export enum AiModel {
  CLAUDE_OPUS = 'claude-opus-5',
  OPENAI_EMBEDDING_3_SMALL = 'text-embedding-3-small',
  OPENAI_GPT_CHAT = 'gpt-5.6-terra',
  OPENAI_GPT_SMALL = 'gpt-5.6-luna',
}
